<script>
  import { External, M } from '../../external';
  import { slide } from 'svelte/transition';
  import PhoneInput from "../../Common/PhoneInput.svelte";
	import DatePicker from "../../Common/DatePicker.svelte";

  export let contact;

  let showWhenCollapsed = ['name', 'email', 'phone'];
  let showAllProperties = false;
  const toggleProperties = () => {
    showAllProperties = !showAllProperties;
  };

  const snakeToCamel = (str) => {
    return str.replace(/_([a-z])/g, function (match, letter) {
      return letter.toUpperCase();
    });
  };
</script>

<section class="contact-details" data-role="properties">
  <label class="label">
    <h5>{M.NAME}</h5>
    <input
      name="name"
      type="text"
      bind:value={contact.data.name}
      on:change={() => {
        contact.updateContactProperty(-1, contact.data.name);
      }} />
  </label>
  <label class="label">
    <h5>{M.EMAIL}</h5>
    <input
      name="email"
      type="email"
      bind:value={contact.data.email}
      on:change={() => {
        contact.updateContactProperty(-2, contact.data.email);
      }} />
  </label>
  <label class="label">
    <h5>{M.PHONE}</h5>
    <PhoneInput name="phone" bind:value={contact.data.phone} onChange={() => {
      contact.updateContactProperty(-3, contact.data.phone);
     }} />
  </label>
  <label class="label">
    <h5>{M.FIRST_SEEN}</h5>
    <input
      class="readonly-input"
      name="firstSeen"
      readonly="readonly"
      type="text"
      bind:value={contact.data.firstSeenValue} />
  </label>
  <!-- <Tags {contact} />-->
  {#if showAllProperties}
    <div class="col20 f-left" class:expanded={showAllProperties} transition:slide data-role="custom-properties">
      {#each External.Website.crmProperties as property, idx}
        {#if !showWhenCollapsed.includes(property.name)}
          <label class="label" class:boolean-label={property.type === External.CRM_PROPERTY_TYPE.BOOLEAN}>
            <h5>{property.label}</h5>
            {#if property.type === External.CRM_PROPERTY_TYPE.STRING}
              {#if property.id < 0}
                <input
                  type="text"
                  bind:value={contact.data[snakeToCamel(property.name)]}
                  on:change={() => {
                    contact.updateContactProperty(property.id, contact.data[snakeToCamel(property.name)]);
                  }} />
              {:else}
                <input
                  type="text"
                  bind:value={contact.data.properties[property.id]}
                  on:change={() => {
                    contact.updateContactProperty(property.id, contact.data.properties[property.id]);
                  }} />
              {/if}
            {:else if property.type === External.CRM_PROPERTY_TYPE.EMAIL}
              {#if property.id < 0}
                <input
                  name={'email' + idx}
                  type="email"
                  bind:value={contact.data[snakeToCamel(property.name)]}
                  on:change={() => {
                    contact.updateContactProperty(property.id, contact.data[snakeToCamel(property.name)]);
                  }} />
              {:else}
                <input
                  name={'email' + idx}
                  type="email"
                  bind:value={contact.data.properties[property.id]}
                  on:change={() => {
                    contact.updateContactProperty(property.id, contact.data.properties[property.id]);
                  }} />
              {/if}
            {:else if property.type === External.CRM_PROPERTY_TYPE.NUMBER}
							{#if property.id < 0}
								<input
									type="number"
									bind:value={contact.data[snakeToCamel(property.name)]}
									on:change={() => {
                    contact.updateContactProperty(property.id, contact.data[snakeToCamel(property.name)]);
                  }} />
							{:else}
								<input
									type="number"
									bind:value={contact.data.properties[property.id]}
									on:change={() => {
                    contact.updateContactProperty(property.id, contact.data.properties[property.id]);
                  }} />
							{/if}
						{:else if property.type === External.CRM_PROPERTY_TYPE.PHONE}
							{#if property.id < 0}
								<PhoneInput name={'field' + idx} bind:value={contact.data[snakeToCamel(property.name)]} onChange={() => {
                    contact.updateContactProperty(property.id, contact.data[snakeToCamel(property.name)]);
                  }} />
							{:else}
								<PhoneInput name={'field' + idx} bind:value={contact.data.properties[property.id]} onChange={() => {
                    contact.updateContactProperty(property.id, contact.data.properties[property.id]);
                  }} />
							{/if}
						{:else if property.type === External.CRM_PROPERTY_TYPE.DATE}
              {#if property.id < 0}
								<DatePicker bind:value={contact.data[snakeToCamel(property.name)]} onChange={(value) => {
									// Property value is in MS, but we're sending it to the server in unix seconds. (don't ask...)
									contact.updateContactProperty(property.id, value / 1000);
								}} />
              {:else}
								<DatePicker bind:value={contact.data.properties[property.id]} onChange={(value) => {
									// Property value is in MS, but we're sending it to the server in unix seconds. (don't ask...)
									contact.updateContactProperty(property.id, value / 1000);
								}} />
              {/if}
            {:else if property.type === External.CRM_PROPERTY_TYPE.LIST}
              {#if property.id < 0}
                <select
									name={'field' + idx}
                  bind:value={contact.data[snakeToCamel(property.name)]}
                  on:change={() => {
                    contact.updateContactProperty(property.id, contact.data[snakeToCamel(property.name)]);
                  }}>
									<option value=""></option>
                  {#each property.value as option}
                    <option value={option}>{option}</option>
                  {/each}
                </select>
              {:else}
                <select
									name={'field' + idx}
                  bind:value={contact.data.properties[property.id]}
                  on:change={() => {
                    contact.updateContactProperty(property.id, contact.data.properties[property.id]);
                  }}>
									<option value=""></option>
                  {#each property.value as option}
                    <option value={option}>{option}</option>
                  {/each}
                </select>
              {/if}
            {:else if property.type === External.CRM_PROPERTY_TYPE.BOOLEAN}
              <div class="boolean-toggle">
                {#if property.id < 0}
                  <a
                    class="boolean-toggle-option"
                    class:selected={contact.data[snakeToCamel(property.name)]}
                    on:click={() => {
                      contact.data[snakeToCamel(property.name)] = true;
                      contact.updateContactProperty(property.id, 1);
                    }}>{M.YES}</a>
                  <a
                    class="boolean-toggle-option"
                    class:selected={!contact.data[snakeToCamel(property.name)]}
                    on:click={() => {
                      contact.data[snakeToCamel(property.name)] = false;
                      contact.updateContactProperty(property.id, null);
                    }}>{M.NO}</a>
                {:else}
                  <a
                    class="boolean-toggle-option"
                    class:selected={contact.data.properties[property.id]}
                    on:click={() => {
                      contact.data.properties[property.id] = true;
                      contact.updateContactProperty(property.id, 1);
                    }}>{M.YES}</a>
                  <a
                    class="boolean-toggle-option"
                    class:selected={!contact.data.properties[property.id]}
                    on:click={() => {
                      contact.data.properties[property.id] = false;
                      contact.updateContactProperty(property.id, null);
                    }}>{M.NO}</a>
                {/if}
              </div>
            {:else if property.type === External.CRM_PROPERTY_TYPE.COUNTRY}
              {#if property.id < 0}
                <select
									name={'field' + idx}
                  bind:value={contact.data[snakeToCamel(property.name)]}
                  on:change={() => {
                    contact.updateContactProperty(property.id, contact.data[snakeToCamel(property.name)]);
                  }}>
                  {#each External.COUNTRIES as country, index (country)}
                    <option value={External.COUNTRY_CODES[index]}>{country}</option>
                  {/each}
                </select>
              {:else}
                <select
									name={'field' + idx}
                  bind:value={contact.data.properties[property.id]}
                  on:change={() => {
                    contact.updateContactProperty(property.id, contact.data.properties[property.id]);
                  }}>
                  {#each External.COUNTRIES as country, index (country)}
                    <option value={External.COUNTRY_CODES[index]}>{country}</option>
                  {/each}
                </select>
              {/if}
            {/if}
          </label>
        {/if}
      {/each}
    </div>
  {/if}
  <a class="blue-text f-left col20 mt-5" on:click={toggleProperties}>
		{!showAllProperties ? M.SHOW_ALL_PROPERTIES : M.SHOW_LESS_PROPERTIES}
	</a>
</section>
